export function passengerCount(adults, childAges) {
    return {
        adults,
        children: childAges === null || childAges === void 0 ? void 0 : childAges.filter((child) => child >= 2).length,
        infants: childAges === null || childAges === void 0 ? void 0 : childAges.filter((child) => child < 2).length,
    };
}
